import styled from 'styled-components';
import { Typography, Button, Modal } from 'antd';

import colors from '../../styles/colors';

const { Text } = Typography;

export const ModalContent = styled(Modal)`
  .ant-modal-content {
    border-radius: 2px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  }
`;

export const ContenModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 44px 28px 36px 28px;
`;

export const Title = styled(Text)`
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: ${colors.greyText};
`;

export const ContainerButtons = styled.div`
  width: 80%;
  margin-top: 37px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const ButtonCustom = styled(Button)`
  width: 120px;
  font-weight: bold;
  border-radius: 0;
`;

export const ContainerInput = styled.div`
  margin: 14px 0 0 0;
  width: 85%;
`;
